import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import { addAudit } from "../audits/addAudits";
import {
  Card,
  CardAreaMain,
  CardContent,
  Button,
  CardActions,
  CardActionsSupplemental,
  CircleProgress
} from "reactackle";
import {
  actionAddArray2Redux,
  selectARecord,
  uploadPhoto,
  deletePhoto
} from "../../../../store/actions";
import { getCaption } from "../landingPage/getMenuList";
import { isMobile } from "react-device-detect";
import checkBeforeSave from "../../checkBeforeSave/checkBeforeSave";
import getInputField from "../customFields/getInputField";

class SingleRecord extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        ...this.props.selectedRecord
      },
      userEmail: this.props.userProfile.userEmail
    },
    showForm: true
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(
        prevState => {
          if (prevState && prevState.data.payload !== null) {
            return {
              ...prevState,
              data: {
                ...prevState.data,
                payload: {
                  ...prevState.data.payload,
                  ...tmpState
                }
              }
            };
          } else {
            return {
              ...prevState,
              data: {
                path: prevState.data.path,
                payload: {
                  ...tmpState
                }
              }
            };
          }
        },
        () => {
          this.procCalcFields(id);
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ...prevState,
            ...tmpState
          };
        },
        () => {
          this.procCalcFields(id);
        }
      );
    }
  };

  procCalcFields = id => {
    //console.log("Checking ID: " + id);
    let allFields = this.props.ogTableDef[this.props.path];
    for (let key in allFields) {
      let fldDef = allFields[key];
      if (fldDef.type === "calculation" && id === fldDef.triggerField) {
        //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
        if (fldDef.calcType === "subFieldsSum") {
          if (fldDef.subFieldOperation === "SUM") {
            this.getSubGridSum(
              fldDef.name,
              fldDef.subGridName,
              fldDef.subGridField
            );
          } else {
          }
        } else if (fldDef.calcType === "mainFieldCalc") {
          this.getCalcdField(fldDef.name, fldDef.formula);
        }
      }
    }
  };

  getValue = (stateVal, operand) => {
    let res = 0.0;
    if (stateVal !== undefined) {
      if (!isNaN(stateVal)) {
        res = parseFloat(stateVal);
      }
    } else {
      if (!isNaN(operand)) {
        res = parseFloat(operand);
      }
    }
    return res;
  };

  getCalcdField = (calcFieldName, calcRules) => {
    //console.log(calcFieldName + " " + JSON.stringify(calcRules));
    let result = 0.0;

    //currently only one rule will work
    let currRule = calcRules[0];
    if (currRule && currRule !== undefined) {
      let val1 = this.getValue(
        this.state.data.payload[currRule.operand1],
        currRule.operand1
      );
      let val2 = this.getValue(
        this.state.data.payload[currRule.operand2],
        currRule.operand2
      );
      let op = currRule.operation;
      if (op && !isNaN(val1) && !isNaN(val2)) {
        if (op === "+") {
          result = val1 + val2;
        } else if (op === "-") {
          result = val1 - val2;
        } else if (op === "*") {
          result = val1 * val2;
        } else if (op === "/") {
          result = val1 / val2;
        }
      }
      // console.log(
      //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
      // );
      if (result !== undefined && !isNaN(result)) {
        this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
      }
    }
  };

  getSubGridSum = (calcFieldName, subGridName, subFieldToProcess) => {
    let items = this.state.data.payload[subGridName];

    if (items && items !== undefined && items.length > 0) {
      let invSum = items.reduce((sum, obj) => {
        //console.log(obj[subFieldToProcess]);
        if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
          return sum + parseFloat(obj[subFieldToProcess]);
        } else {
          return sum;
        }
      }, 0);
      invSum = invSum.toFixed(2);
      this.stateChangeHandler(invSum, calcFieldName, true);
    }
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      this.props.path,
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef,
      this.props.db,
      isMobile
    );
  };

  getFields = () => {
    // console.log(
    //   this.props.path +
    //     " = " +
    //     JSON.stringify(this.props.ogTableDef[this.props.path])
    // );
    return Object.keys(this.props.ogTableDef[this.props.path]).map(fldKey => {
      return this.getField(fldKey);
    });
  };

  uploadPhotos = dbKey => {
    let tableDef = this.props.ogTableDef[this.props.path];
    let tgtArray = [];
    Object.keys(tableDef).map(fldKey => {
      let fldDef = tableDef[fldKey];
      if (fldDef.type == "photoUpload") {
        let srcArray = this.state[fldKey];
        if (srcArray && srcArray.length > 0) {
          for (let i = 0; i < srcArray.length; i++) {
            let photoSource = srcArray[i];
            if (photoSource.action === "") {
            } else if (photoSource.action === "ADD") {
              //some action to add photo

              this.props.onUploadPhoto(
                this.props.firebase,
                photoSource.imageName,
                "images",
                photoSource.blob,
                dbKey,
                this.props.path
              );
            } else if (photoSource.action === "REMOVE") {
              //console.log(JSON.stringify(photoSource));
              this.props.onDeletePhoto(
                this.props.firebase,
                photoSource.imageName,
                "images",
                dbKey,
                this.props.path
              );
              //some action delete photo
            }
          }
        }
      }
    });
  };

  saveHandler = () => {
    console.log("before");
    //console.log(JSON.stringify(this.props.ogTableDef[this.props.path]));

    console.log("after");
    this.stateChangeHandler(this.props.userEmail, "author", true);
    this.stateChangeHandler(false, "showForm", false);

    let cloudPath = "";
    if (
      this.state.data.payload &&
      this.state.data.payload.key &&
      this.state.data.payload.key !== ""
    ) {
      cloudPath = this.props.path + "/" + this.state.data.payload.key;
      Promise.all([
        addAudit(
          this.stateChangeHandler,
          this.props.firebase.auth.currentUser.phoneNumber
        )
      ]).then(res => {
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(this.state.data.payload);
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            this.uploadPhotos(this.state.data.payload.key);
            this.props.genNotification(this.state.data.payload, "update");
            this.props.handleEditCancel();
          });
      });
    } else {
      cloudPath = this.props.path;
      Promise.all([
        addAudit(
          this.stateChangeHandler,
          this.props.firebase.auth.currentUser.phoneNumber
        )
        //get new ID
      ]).then(res => {
        var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
        newInv
          .set(this.state.data.payload)
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {
            //console.log(newInv.key);
            this.uploadPhotos(newInv.key);
            this.props.genNotification(this.state.data.payload, "create");
            this.props.handleEditCancel();
          });
      });

      //this.props.handleEditCancel();
    }
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress indeterminate subtitle="Saving..." />
      </CardContent>
    );
  };

  getTopHeader = () => {
    return (
      <div>
        <Card>
          <CardAreaMain>
            {!isMobile && (
              <CardContent>
                <div>
                  <h1>
                    {getCaption(this.props.path, this.props.db["listOfTables"])}
                  </h1>
                </div>
              </CardContent>
            )}
            <CardActions>
              <CardActionsSupplemental>
                {this.props.operationType !== "add" && (
                  <Button
                    text="DELETE"
                    onPress={e => {
                      if (
                        this.state.data.payload.key &&
                        this.state.data.payload.key !== ""
                      ) {
                        window.confirm(
                          "Are you sure you wish to delete this item?"
                        ) &&
                          this.props.handleDelete(
                            this.state.data.payload.key,
                            this.props.path,
                            this.state.data.payload
                          );
                      }
                    }}
                    colorScheme="warning"
                    disabled={!this.state.showForm}
                  />
                )}

                <Button
                  text="SAVE"
                  onPress={() => this.saveHandler()}
                  colorScheme="primary"
                  disabled={
                    !this.state.showForm ||
                    checkBeforeSave(
                      this.props.path,
                      this.state.data.payload,
                      this.props.ogTableDef
                    )
                  }
                />

                <Button
                  text="CANCEL"
                  onPress={() => this.props.handleEditCancel()}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </CardActionsSupplemental>
            </CardActions>
          </CardAreaMain>
        </Card>
      </div>
    );
  };

  render() {
    return (
      <div
        style={{
          minHeight: 800,
          marginTop: "60px"
        }}
      >
        <div>{this.getTopHeader()}</div>
        {isMobile && (
          <div>
            {this.state.showForm && this.getFields()}
            {!this.state.showForm && this.getLoader()}
          </div>
        )}
        {!isMobile && (
          <Card>
            <CardAreaMain style={{ padding: "0px" }}>
              <CardContent style={{ pading: "0px" }}>
                {this.state.showForm && this.getFields()}
                {!this.state.showForm && this.getLoader()}
              </CardContent>
            </CardAreaMain>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail:
      state.db.currentUser && state.db.currentUser.userEmail
        ? state.db.currentUser.userEmail
        : "",
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userProfile: state.db.userProfile,
    selectedRecord: state.db["selected" + state.ui.tableName],
    db: state.db,
    createNewRec: state.ui.operationType === "add",
    operationType: state.ui.operationType
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => dispatch(selectARecord(params)),
    onUploadPhoto: (firebase, photoName, photoPath, blob, dbKey, cloudPath) =>
      dispatch(
        uploadPhoto(firebase, photoName, photoPath, blob, dbKey, cloudPath)
      ),
    onDeletePhoto: (firebase, photoName, photoPath, dbKey, cloudPath) =>
      dispatch(deletePhoto(firebase, photoName, photoPath, dbKey, cloudPath))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(SingleRecord);



// WEBPACK FOOTER //
// ./src/app/components/Screens/SingleRecord/SingleRecord.jsx